var map = {
	"./shu_1.png": "9b92",
	"./shu_2.png": "1b82",
	"./shu_3.png": "69ea",
	"./shu_4.png": "3779",
	"./shu_5.png": "6091",
	"./shu_6.png": "548f",
	"./ying_1.png": "d052",
	"./ying_2.png": "fe9d",
	"./ying_3.png": "90ac",
	"./ying_4.png": "11f1",
	"./ying_5.png": "bee8",
	"./ying_6.png": "99a6",
	"./yu_1.png": "2b01",
	"./yu_2.png": "39b1",
	"./yu_3.png": "038b",
	"./yu_4.png": "3169",
	"./yu_5.png": "1160",
	"./yu_6.png": "e720"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0e9b";